import { Alert, Box, Divider, List, ListItem, Typography } from '@mui/material';
import ApplePhoneHomeScreen from 'assets/images/addFI/ApplePhoneHomeScreen.png';
import AppleWalletLogo from 'assets/logos/apple.svg';
import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';
import React from 'react';

const instructions = [
  { id: 1, instruction: 'Go to the Accounts page on your Simplifi app.' },
  { id: 2, instruction: 'Tap the ➕ icon in the top right corner.' },
  { id: 3, instruction: 'Select "Apple Wallet" from the list.' },
  { id: 4, instruction: 'Follow the prompts to complete the connection.' },
];

type AppleWalletInstructionsProps = {
  handleGotItClick: () => void;
};

export default function AppleWalletInstructions(props: AppleWalletInstructionsProps) {
  const { handleGotItClick } = props;

  return (
    <>
      <StdDialogContent id='apple_wallet_instructions_dialog'>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', pb: 1.5 }}>
            <Box sx={{ pl: 1.5, pr: 4 }}>
              <img
                src={AppleWalletLogo}
                alt='Apple Wallet logo'
                style={{ borderRadius: '50%' }}
                height={80}
                width={80}
              />
            </Box>
            <Box>
              <Typography variant='headlineMedium'>Apple Wallet</Typography>
              <Typography variant='bodyRegular' color='textTertiary'>
                {`Use Simplifi iOS app to connect`}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Box sx={{ pl: 14 }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', gap: 2 }}>
              <Box sx={{ flex: 4, pt: 5 }}>
                <Typography variant='bodyMedium'>
                  {`To connect your Apple Wallet, you'll need to complete the setup on your iOS device.`}
                </Typography>
                <Box>
                  <Box sx={{ pl: 1, pt: 1, pb: 2.5 }}>
                    <List component='ol' sx={{ listStyleType: 'decimal', pl: 1.5 }}>
                      {instructions.map((item) => (
                        <ListItem
                          key={item.id}
                          component='li'
                          disablePadding
                          sx={(theme) => ({
                            display: 'list-item',
                            ...theme.typography.paragraphRegular,
                          })}
                        >
                          <Typography variant='paragraphRegular'>{item.instruction}</Typography>
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ flex: 2, pt: 1, pr: 1 }}>
                <img src={ApplePhoneHomeScreen} alt='Apple iPhone home screen' height={200} width={200} />
              </Box>
            </Box>
            <Box>
              <Alert icon={false} severity='info' sx={{ py: 0.25, px: 2 }}>
                {`Note: Apple Wallet connections must be initiated and completed within the Simplifi app on iOS. Due to
                technical limitations, this cannot be done from the desktop.`}
              </Alert>
            </Box>
          </Box>
        </Box>
      </StdDialogContent>
      <StdDialogActions
        primary={{
          children: 'Got it',
          onClick: handleGotItClick,
        }}
      />
    </>
  );
}
